// extracted by mini-css-extract-plugin
module.exports = {"box":"panel_box__lIB7a"};